import { StateCreator } from 'zustand';

import { State, Store } from './types';

const initialState: State = {
  personalWorkspaceId: undefined,
  designWorkspaceId: undefined,
  workspaceForAssets: undefined,
};

export const workspaceStateCreator: StateCreator<Store> = (set) => ({
  ...initialState,
  setPersonalWorkspaceId: (workspaceId?: string | null) =>
    set({ personalWorkspaceId: workspaceId }),
  setDesignWorkspaceId: (workspaceId?: string | null) =>
    set({ designWorkspaceId: workspaceId }),
  setWorkspaceForAssets: (workspaceId?: string | null) =>
    set({ workspaceForAssets: workspaceId }),
  reset: () => set(initialState),
});
